<div class="split">
    <ng-content></ng-content>
    <div class="nav-container" (click)="onNavigateTo(_screen!)">
        <div class="nav">
            @if (_readonly) {
                <mat-icon color="accent" [class.error]="_isValid == false">remove_red_eye</mat-icon>
            } @else {
                <mat-icon color="accent" [class.error]="_isValid == false">edit</mat-icon>
            }
        </div>
    </div>
</div>
